import type { HttpClient } from "../http";
import type { RetailerDTO, UserAccountDTO, RmVisitDTO } from "../types";

export function retailersResource(http: HttpClient) {
  return {
    list: () => http.get<RetailerDTO[]>("/retailers"),
    get: (id: number) => http.get<RetailerDTO>(`/retailers/${id}`),
    create: (body: RetailerDTO) => http.post<RetailerDTO>("/retailers", body),
    update: (id: number, body: RetailerDTO) => http.put<RetailerDTO>(`/retailers/${id}`, body),
    remove: (id: number) => http.del(`/retailers/${id}`),
    delete: (id: number) => http.del(`/retailers/${id}`),
    approve: (id: number) => http.post<RetailerDTO>(`/retailers/${id}/approve`, {}),
    reject: (id: number) => http.patch<RetailerDTO>(`/retailers/${id}/status`, { status: 'REJECTED' }),
    invite: (id: number) => http.post<{ success: boolean; message: string }>(`/retailers/${id}/invite`, {}),
  };
}

export function usersResource(http: HttpClient) {
  return {
    list: () => http.get<UserAccountDTO[]>("/users"),
    get: (id: number) => http.get<UserAccountDTO>(`/users/${id}`),
    create: (body: UserAccountDTO) => http.post<UserAccountDTO>("/users", body),
    update: (id: number, body: UserAccountDTO) => http.put<UserAccountDTO>(`/users/${id}`, body),
    remove: (id: number) => http.del(`/users/${id}`),
  };
}

export function visitsResource(http: HttpClient) {
  return {
    list: (retailerId?: number) => {
      const q = retailerId ? `?retailerId=${encodeURIComponent(retailerId)}` : "";
      return http.get<RmVisitDTO[]>(`/rm/visits${q}`);
    },
    record: (body: RmVisitDTO) => http.post<RmVisitDTO>("/rm/visits", body),
  };
}
